import { InjectionToken, type Type } from '@angular/core';

/**
 * Extra tabs in the person details drawer, contributed from outside.
 *
 * The drawer lives here, but some of what a person "is" belongs to other
 * modules — her skills to `skill`, and more will follow. Importing those
 * components here would point contacts at them, and they already point at
 * contacts: `person_skill.person_id` references the person table, so skill
 * depends on contacts and the pair would form a cycle the lint rule refuses
 * for good reason.
 *
 * So the drawer declares the hole and the application fills it. Contacts
 * knows there may be further tabs; it does not know what they are.
 */
export interface PersonDetailTab {
  /** Value of the tab trigger — unique among the drawer's tabs. */
  id: string;
  /** Transloco key for the tab's label. */
  labelKey: string;
  /**
   * The panel.
   *
   * It is handed `personId`, `organizationId` (nullable, as the column is)
   * and `canEdit` — the contract every contributed tab is written against.
   */
  component: Type<unknown>;
}

export const PERSON_DETAIL_TABS = new InjectionToken<readonly PersonDetailTab[]>(
  'PERSON_DETAIL_TABS',
  { factory: () => [] },
);
